import Lang from "../../common/lang/Lang";

export const urls = {
  home: "/settings/",
  list: "/settings/common-setting",
}

export const ListBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.common_setting,
    url: "#"
  }
];

export const CreateBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.common_setting,
    url: urls.list
  },
  {
    label: Lang.create,
    url: '#'
  }
];

export const EditBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.common_setting,
    url: urls.list
  },
  {
    label: Lang.edit,
    url: '#'
  }
];